const events = ['mousemove', 'keydown']
let removeListenresCallback = () => {}

export const setIdleTimeout = (idleTime, onIdleCallback, onUnidleCallback) => {
  let timeout = 0
  startTimer()

  function startTimer() {
    timeout = setTimeout(() => {
      timeout = 0
      onIdleCallback()
    }, idleTime)

    for (const event of events) {
      document.addEventListener(event, onActivity)
    }
  }

  function onActivity() {
    if (timeout) {
      clearTimeout(timeout)
    } else {
      onUnidleCallback()
    }
    // since the mouse is moving, we turn off our event hooks for 1 second
    for (const event of events) {
      document.removeEventListener(event, onActivity)
    }
    setTimeout(startTimer, 1000)
  }

  removeListenresCallback = onActivity
}

export const removeIdleListeners = () => {
  for (const event of events) {
    document.removeEventListener(event, removeListenresCallback)
  }
}
